//@ts-nocheck
import React from "react";

const GroupIcon = ({
  width = 24,
  height = 24,
  color = "black",
}: {
  width?: number | string;
  height?: number | string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={color}
      width={width}
      height={height}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6a3 3 0 110 6 3 3 0 010-6zM6.75 18a6.75 6.75 0 0110.5 0M4.5 6.75a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zM19.5 6.75a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zM3 18a9 9 0 0118 0"
      />
    </svg>
  );
};

export default GroupIcon;